export default __webpack_public_path__ + "static/Post_image_logo-59afe7f345c644f4410da32535e595ec.png";